/**
 * Servicio API para gestión de Delegaciones Físicas
 * @module services/delegationService
 */

import { api } from './api';
import type {
  Delegation,
  DelegationCreate,
  DelegationUpdate,
} from '@/types/delegation.types';

class DelegationService {
  private readonly basePath = '/crm/delegations';

  /**
   * Listar todas las delegaciones
   */
  async list(): Promise<Delegation[]> {
    const response = await api.get<Delegation[]>(this.basePath);
    return response.data;
  }

  /**
   * Crear nueva delegación
   */
  async create(data: DelegationCreate): Promise<Delegation> {
    const response = await api.post<Delegation>(this.basePath, data);
    return response.data;
  }

  /**
   * Obtener delegación por ID
   */
  async getById(id: string): Promise<Delegation> {
    const response = await api.get<Delegation>(`${this.basePath}/${id}`);
    return response.data;
  }

  /**
   * Actualizar delegación
   */
  async update(id: string, data: DelegationUpdate): Promise<Delegation> {
    const response = await api.patch<Delegation>(`${this.basePath}/${id}`, data);
    return response.data;
  }

  /**
   * Eliminar delegación
   */
  async delete(id: string): Promise<void> {
    await api.delete(`${this.basePath}/${id}`);
  }

  /**
   * Obtener delegaciones activas
   */
  async listActive(): Promise<Delegation[]> {
    const delegations = await this.list();
    return delegations.filter((d) => d.is_active);
  }
}

export const delegationService = new DelegationService();
export default delegationService;
